import React, {useEffect, useCallback, useState} from "react";
import { useFormikContext } from "formik";
import debounce from "lodash.debounce";
import CircularProgress from "@material-ui/core/CircularProgress";

const AutoSaveWithDebounce = ({ debounceMs, loaderCircle }) => {
    const formik = useFormikContext();

    const debouncedSubmit = useCallback(debounce(formik.submitForm, debounceMs),
        [formik.submitForm, debounceMs]);

    useEffect(() => {
        formik.dirty && debouncedSubmit()
    }, [debouncedSubmit, formik.dirty, formik.values]);

    return <>{!!formik.isSubmitting && loaderCircle ? <CircularProgress className="p-1"/> : null}</>;
};

export default AutoSaveWithDebounce;


